/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { UserAccountDto } from '../models/user-account-dto';

@Injectable({
  providedIn: 'root',
})
export class UserAccountRestControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getCurrentUser
   */
  static readonly GetCurrentUserPath = '/api/v1/user';

  /**
   * Retrieve currently logged in user data.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCurrentUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCurrentUser$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<UserAccountDto>> {

    const rb = new RequestBuilder(this.rootUrl, UserAccountRestControllerService.GetCurrentUserPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserAccountDto>;
      })
    );
  }

  /**
   * Retrieve currently logged in user data.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCurrentUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCurrentUser(params?: {
  },
  context?: HttpContext

): Observable<UserAccountDto> {

    return this.getCurrentUser$Response(params,context).pipe(
      map((r: StrictHttpResponse<UserAccountDto>) => r.body as UserAccountDto)
    );
  }

  /**
   * Path part for operation getUserAccountById
   */
  static readonly GetUserAccountByIdPath = '/api/v1/user/{id}';

  /**
   * Provides user account based on given id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserAccountById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserAccountById$Response(params: {
    id: number;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<UserAccountDto>> {

    const rb = new RequestBuilder(this.rootUrl, UserAccountRestControllerService.GetUserAccountByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserAccountDto>;
      })
    );
  }

  /**
   * Provides user account based on given id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserAccountById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserAccountById(params: {
    id: number;
  },
  context?: HttpContext

): Observable<UserAccountDto> {

    return this.getUserAccountById$Response(params,context).pipe(
      map((r: StrictHttpResponse<UserAccountDto>) => r.body as UserAccountDto)
    );
  }

  /**
   * Path part for operation deleteUserAccount
   */
  static readonly DeleteUserAccountPath = '/api/v1/user/{id}';

  /**
   * Removes useraccount with all cvs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteUserAccount()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteUserAccount$Response(params: {
    id: number;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, UserAccountRestControllerService.DeleteUserAccountPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Removes useraccount with all cvs.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteUserAccount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteUserAccount(params: {
    id: number;
  },
  context?: HttpContext

): Observable<void> {

    return this.deleteUserAccount$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
